import React from 'react';
import { Dropdown as AntDropdown } from 'antd';
import Button from '../form/Button';
import Icon from './Icon';
import { Menu } from 'antd';

const Dropdown = (props) => (
  <AntDropdown
    overlay={
      <Menu style={{ padding: '5px' }}>
        {props.menuItems.map((e) => (
          <Menu.Item key={`${e.label}-${e.key}`} onClick={e.onClick}>
            <Icon style={{ fontSize: 14 }} name={e.icon} />
            {e.label}
          </Menu.Item>
        ))}
      </Menu>
    }
    trigger={[props.type]}
    placement={props.buttonPlace}
  >
    <Button icon="menu" label={<Icon name="caret-down" style={{ marginLeft: '2px' }} />} />
  </AntDropdown>
);

export default Dropdown;
